module.exports = __webpack_public_path__ + "img/placeholder.759e3e1c.jpg";